(function(){
    angular
        .module('app')
        .directive('ngSticky', ngsticky);

        ngsticky.$inject = ['$timeout','$window'];
        function ngsticky($timeout,$window){
        	var $win = angular.element($window); // wrap window object as jQuery object
            return {
            	link: function (scope, element, $attrs) {
		            return $timeout(function () {
		            	//console.log("STICKY");
		            	var topClass = "stick"; // get CSS class from directive's attribute value
			            var elementTop = element.offset().top;

			            $win.on('scroll', function (e) {
			            	//console.log(genLab)
			            	 // get element's top relative to the document
				            //console.log("S",$win.scrollTop());
				            //console.log("E",elementTop);
			                if ($win.scrollTop() >= elementTop) {
			                    element.addClass(topClass);
			                } else {
			                    element.removeClass(topClass);
			                }
				            
			            });

			        });
		        }
          }
      }
})();